import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router} from '@angular/router';

import {AuthService} from '../services/auth.service';
import {Observable} from 'rxjs/Rx';
// import "rxjs/add/operator/take";
// import "rxjs/add/operator/map";
// import "rxjs/add/operator/do";


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {


  constructor(private router: Router, private auth: AuthService) {
  }

  canActivate(): Observable<boolean> {
    return this.auth.getCurrentUser()
      .take(1)
      .map(user => !!user)
      .do(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/pages/login']);
        }
      });
  }
  canActivateChild() {
    return this.auth.getCurrentUser()
      .take(1)
      .map(user => !!user)
      .do(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['/pages/login']);
        }
      });
  }
}

@Injectable()
export class AdminGuard implements CanActivate, CanActivateChild {


  constructor(private router: Router, private auth: AuthService) {
  }

  canActivate(): Observable<boolean> {
    return this.auth.getUserType()
      .take(1)
      .map(type => type === 'admin')
      .do(allowed => {
        if (!allowed) {
          this.router.navigate(['/pages/login']);
        }
      });
  }
  canActivateChild() {
    return this.auth.getUserType()
      .take(1)
      .map(type => type === 'admin')
      .do(allowed => {
        if (!allowed) {
          this.router.navigate(['/pages/login']);
        }
      });
  }
}

@Injectable()
export class PartnerGuard implements CanActivate, CanActivateChild {


  constructor(private router: Router, private auth: AuthService) {
  }

  canActivate(): Observable<boolean> {
    return this.auth.getCurrentUser().take(1)
      .flatMap(user => {return Observable.fromPromise(user.getIdToken()).map(idToken => {
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      return !!payload['partner']; });
      }).do(allowed => {
            if (!allowed) {
              this.router.navigate(['/pages/login']);
            }
          });

    // return this.auth.getUserType()
    //   .first()
    //   .map(type => type === 'partner')
    //   .do(allowed => {
    //     if (!allowed) {
    //       this.router.navigate(['/pages/login']);
    //     }
    //   });
  }
  canActivateChild() {
    return this.auth.getCurrentUser().take(1)
      .flatMap(user => {return Observable.fromPromise(user.getIdToken()).map(idToken => {
        const payload = JSON.parse(atob(idToken.split('.')[1]));
        return !!payload['partner']; });
      });
    // return this.auth.getUserType()
    //   .first()
    //   .map(type => type === 'partner')
    //   .do(allowed => {
    //     if (!allowed) {
    //       this.router.navigate(['/pages/login']);
    //     }
    //   });
  }
}

// @Injectable()
// export class Verified implements CanActivate {
//
//
//   constructor(private router: Router, private auth: AuthService) {
//   }
//
//   canActivate(): Observable<boolean> {
//     return this.auth.getCurrentUser()
//       .take(1)
//       .map(user => !!user)
//       .do(loggedIn => {
//         if (!loggedIn) {
//           this.router.navigate(['/pages/verify']);
//         }
//       })
//   }
//   canActivateChild(): Observable<boolean>  {
//     return this.auth.getCurrentUser()
//       .take(1)
//       .map(user => {
//         if (user) {
//           return user.emailVerified;
//         } else {
//           return false;
//         }
//       })
//       .do(verified => {
//         if (!verified) {
//           this.router.navigate(['/pages/verify']);
//         }
//       })
//   }
//
// }



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/shared/security/auth.guard.ts